import { API } from 'api';
import { AxiosResponse } from 'axios';
import {
	IGenerateReportsRequest,
	IGetPaymentReportsDto,
	IGetPaymentReportsResponse,
	IReceiptRequest,
	IReportData,
	IReportSingleReceiptResponse,
	IGenerateReestrFuaReportRequest,
	IReportsRequest,
	IRevisePortmoneSummaryRequest,
} from 'types';
import { API_URL } from 'utils/enums';
import { removeEmptyProps } from 'utils/helpers';

class ReportsService {
	static generateReports = async (reqBody: IGenerateReportsRequest): Promise<AxiosResponse> =>
		API.post(API_URL.REPORTS_GENERATE, reqBody);

	static generateReestrFuaReport = async (reqBody: IGenerateReestrFuaReportRequest): Promise<AxiosResponse> =>
		API.post(API_URL.REESTR_FUA_REPORT_GENERATE, reqBody);

	static revisePortmoneSummary = async (reqBody: IRevisePortmoneSummaryRequest): Promise<AxiosResponse<string>> =>
		API.post(API_URL.PORTMONE_REVISE_SUMMARY, reqBody);

	static getReportsList = async (reqBody: IReportsRequest): Promise<AxiosResponse<IReportData[]>> =>
		API.post(API_URL.REPORTS_LIST_GET, reqBody);

	static getPaymentReports = async (reqBody: IGetPaymentReportsDto): Promise<AxiosResponse<IGetPaymentReportsResponse>> =>
		API.post(API_URL.REPORTS_PAYMENT_LIST_GET, reqBody);

	static deleteReportById = async (id: number): Promise<AxiosResponse> =>
		API.delete(`${API_URL.REPORT_DELETE}?id=${id}`);

	static getReportSingleReceipt = async (
		reqBody: IReceiptRequest
	): Promise<AxiosResponse<IReportSingleReceiptResponse>> =>
		API.post(API_URL.REPORT_GET_SINGLE_RECEIPT, removeEmptyProps(reqBody));

	static getReportListById = async (billSingleReceiptId: number): Promise<any> =>
		API.post(API_URL.REPORT_LIST_PAYMENT_GET, { billSingleReceiptId });
}

export { ReportsService };
